export default function brokerStatus(state = 'disconnected', action) {
    switch (action.type) {
        case "CONNECTED":
            return 'connected';
        case "DISCONNECTED":
            return 'disconnected';
        default:
            return state;
    }
}